import { Dispatch, SetStateAction } from 'react';
import { UsersResponse } from '../../service/service.type';
import { PlayerUpdate, POIClassification, UserType } from '@inplay/models';
import { Sweep } from '../../utils/helper.type';

export type SweepEditModalProps = {
  footerButtonText: string;
  onCloseEditModal: () => void;
  selectedSweep?: Sweep;
  usersSummary: UsersResponse | undefined;
  setSelectedSweep: Dispatch<SetStateAction<Sweep | undefined>>;
  loggedUserType?: UserType | null;
};

export const defaultNewPlayer: PlayerUpdate = {
  id: '',
  bodyImage: '',
  description: '',
  presentDuringSweep: true,
  poiClassification: POIClassification.POI,
  consecutiveSweepsCount: 0,
  consecutiveSweepsFlag: true,
  startTime: undefined,
  endTime: undefined,
};
